import { LandingPage } from './screens/LandingPage/LandingPage'

const newHome = () => {
  return (
    <LandingPage />
  )
}

export default newHome